module.exports = __webpack_public_path__ + "img/GainPerception.92331487.png";